// extracted by mini-css-extract-plugin
export default {"transform":"Transformer_transform__uRgmt"};